import { Row } from 'antd';
import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';

import styles from './index.module.scss';

type AlertProps = {
	text: string | ReactNode;
	path?: string;
	linkText?: string;
	isButton?: boolean;
	onClick?: () => void;
	target?: string;
};
export function Alert({ text, path, linkText, isButton, onClick, target }: AlertProps) {
	return (
		<div className={styles.verify}>
			<Row className={styles.row}>
				<InfoIcon />
				{text}
			</Row>
			<Row className={styles.row}>
				{path && (
					<Link
						to={path}
						target={target}
						state={{ fromOverview: true }}
						className={styles.verifyButton}
					>
						<span>{linkText}</span>
					</Link>
				)}
				{isButton && (
					<button className={styles.verifyButton} onClick={onClick}>
						<span>{linkText}</span>
					</button>
				)}
			</Row>
		</div>
	);
}
